/**
 * 1stbuddha — share-button.js
 *
 * <share-button data-url data-title data-copied> wrapping a <button>:
 * opens the native share sheet where there is one, otherwise copies the link
 * and shows a toast (data-copied).
 */
(() => {
  if (customElements.get('share-button')) return;

  class ShareButton extends HTMLElement {
    connectedCallback() {
      this.querySelector('button')?.addEventListener('click', () => this.share());
    }

    async share() {
      const url = this.dataset.url || window.location.href;
      if (navigator.share) {
        try {
          await navigator.share({ title: this.dataset.title || document.title, url });
          return;
        } catch (error) {
          if (error?.name === 'AbortError') return;
        }
      }
      try {
        await navigator.clipboard.writeText(url);
        document.dispatchEvent(new CustomEvent('toast:show', { detail: { message: this.dataset.copied } }));
      } catch {
        /* no clipboard access: nothing else to offer */
      }
    }
  }

  customElements.define('share-button', ShareButton);
})();
